function DistroyElement(elem) {
    const element = document.getElementById(elem);
  element.remove();
}

function RemoveInnerHtml(elem) {
    document.getElementById(elem).innerHTML = "";
}
